import React from 'react';
import SharedFindTheLetterActivity from '@monorepo/shared/src/components/activities/FindItActivities/components/FindTheLetterActivity';
import ActivityHeaderLayout from '@monorepo/shared/src/components/activities/ActivityHeaderLayout';
import ActivityHeader from '@monorepo/shared/src/components/activities/ActivityHeader';
import FindItActivityProgress from '@monorepo/shared/src/components/activities/FindItActivityProgress';
import useGame from '@monorepo/shared/src/hooks/use-game';
import HintButton from '@monorepo/shared/src/components/modules/Paging/components/HintButton';
import NavigationControl from '@monorepo/shared/src/components/modules/Paging/components/NavigationControl';
import ArrowNavigationButton from '@monorepo/shared/src/components/activities/ArrowNavigationButton';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import ZoomProvider from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Zoom/providers/ZoomProvider';
import ZoomWrapper from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Zoom/components/ZoomWrapper';
import { useWindowSize } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-window-size';
import makeStyles from '@mui/styles/makeStyles';
import {
  ActivityTypes,
  FindTheLetterInterface,
} from '@monorepo/shared/src/providers/GameProvider/types';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

type Props = {
  backRoute?: string;
};

const heightOffset = theme.constants.app.menuOffset + theme.constants.app.footerOffset;

const FindTheLetterActivity: React.FC<Props> = ({ backRoute }) => {
  const { height: windowHeight } = useWindowSize();
  const classes = useStyles({ windowHeight });
  const [{ activityData }, { handleTurnActivityPage }] = useGame<FindTheLetterInterface>();
  const omitRoutes = useTrialUserOmitRoutes();

  const Footer = () => (
    <div className={classes.footer}>
      <FindItActivityProgress activityType={ActivityTypes.FIND_THE_LETTER} />
      <div className={classes.hintWrapper}>
        <HintButton />
      </div>
    </div>
  );

  return (
    <>
      <ActivityHeaderLayout
        title={activityData?.description}
        hasTogglePageView={true}
        backRoute={backRoute}
        Header={ActivityHeader}
        Footer={<Footer />}
        omitRoutes={omitRoutes}
      />
      <NavigationControl
        handleContinue={handleTurnActivityPage}
        ArrowNavigationButton={ArrowNavigationButton}
      />
      <ZoomProvider>
        <div className={classes.wrapper}>
          <ZoomWrapper>
            <SharedFindTheLetterActivity />
          </ZoomWrapper>
        </div>
      </ZoomProvider>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: ({ windowHeight }: any) => theme.typography.pxToRem(windowHeight - heightOffset),
    padding: `${theme.typography.pxToRem(24)} ${theme.typography.pxToRem(60)}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    justifySelf: 'center',
    height: theme.typography.pxToRem(theme.constants.app.footerOffset),
    zIndex: 2,
  },
  hintWrapper: {
    position: 'absolute',
    display: 'flex',
    gridGap: '1rem',
    right: '4.5%',
    bottom: '1.5rem',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
}));

export default FindTheLetterActivity;
